import { useTranslation } from 'react-i18next';
import { GLOBAL_NAVIGATION_HEIGHT } from '@/shared/lib/constants';
import { useRouteSidePanelStore } from '@/shared/stores/side-panel-store';
import { Banner } from '@/shared/ui';
import { SideMenuHeader } from '@/widgets/right-side-menu/ui/SideMenuHeader';
import { AccountingTypesCreateForm } from './AccountingTypesCreateForm';

export const AccountingTypesSidePanel = () => {
  const { t } = useTranslation();
  const requestClose = useRouteSidePanelStore((state) => state.requestClose);
  const mode = useRouteSidePanelStore((state) => state.mode);

  const modeData = mode?.type === 'master-management.accounting-types' ? mode : undefined;

  const title =
    modeData?.mode === 'edit'
      ? t('master-management.accounting-types.edit.title')
      : t('master-management.accounting-types.create.title');

  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ height: `calc(100vh - ${GLOBAL_NAVIGATION_HEIGHT}px)` }}
    >
      <SideMenuHeader
        title={title}
        onClose={() => {
          requestClose();
        }}
      />
      {modeData?.mode === 'create' && (
        <AccountingTypesCreateForm
          mode="create"
          fiscalYear={modeData.fiscalYear}
          onClose={requestClose}
        />
      )}
      {modeData?.mode === 'edit' && (
        <AccountingTypesCreateForm
          mode="edit"
          fiscalYear={modeData.fiscalYear}
          accountingType={modeData.accountingType}
          onClose={requestClose}
        />
      )}
      {!modeData && (
        <Banner
          type="error"
          title={t('common.status.error')}
          description={t('common.status.no-data')}
        />
      )}
    </div>
  );
};
